/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxAlignBottomRight = createReactComponent(
  "box-align-bottom-right",
  "IconBoxAlignBottomRight",
  [
    [
      "path",
      {
        d: "M19 13h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1v-5a1 1 0 0 0 -1 -1z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M20 9v.01", key: "svg-1" }],
    ["path", { d: "M20 4v.01", key: "svg-2" }],
    ["path", { d: "M15 4v.01", key: "svg-3" }],
    ["path", { d: "M9 4v.01", key: "svg-4" }],
    ["path", { d: "M9 20v.01", key: "svg-5" }],
    ["path", { d: "M4 4v.01", key: "svg-6" }],
    ["path", { d: "M4 9v.01", key: "svg-7" }],
    ["path", { d: "M4 15v.01", key: "svg-8" }],
    ["path", { d: "M4 20v.01", key: "svg-9" }]
  ]
);

export { IconBoxAlignBottomRight as default };
//# sourceMappingURL=IconBoxAlignBottomRight.js.map
